var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHexagon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 134.247,
    height: 147.72
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.248 46.818V100.9a13.869 13.869 0 01-.144 2.439 19.674 19.674 0 01-9.816 14.776l-47.059 26.969a19.619 19.619 0 01-14.728 2.008 20.543 20.543 0 01-5.2-2.008l-47.2-27.113a19.968 19.968 0 01-10.1-17.214V46.818A19.678 19.678 0 019.961 29.6l47.2-26.969A19.982 19.982 0 0172.033.628a25.8 25.8 0 015.2 2.008L124.287 29.6a20.041 20.041 0 019.96 17.214z",
    fill: "currentColor",
    "data-name": 13
  })));
}
export default SvgHexagon;